import type { AppTableChangeEvent, AppTableSorter } from '../../../ui';

export const getSort = (sorters: AppTableSorter[]): AppTableChangeEvent['sort'] => {
  if (!sorters.length) {
    return null;
  }

  return sorters
    .filter((item) => !!item.order)
    .sort((a, b) => (a.weight ?? 999) - (b.weight ?? 999))
    .map((item) => ({
      property: item.dataIndex.join('.'),
      order: item.order!,
      weight: item.weight,
    }));
};
